








import headerComponents from '@/layout/Header.vue';
import home from '@/views/Index.vue';
import footerComponents from '@/layout/Footer.vue';

export default {
	components: {
		headerComponents,
		footerComponents,
		home,
	},
};
